import React, { Fragment } from 'react';
import { ButtonToolbar } from 'reactstrap';

interface Props {
  buttons: any[];
  className?: string;
  position?: 'right' | 'between' | 'left';
  style?: React.CSSProperties;
  buttonFilter?: React.ReactElement;
}
const Toolbar = (props: Props) => {
  const { buttons, className = '', position = 'right', buttonFilter } = props;
  return (
    <ButtonToolbar
      className={`${
        position == 'right'
          ? 'justify-content-end'
          : position == 'between'
          ? 'justify-content-between'
          : 'justify-content-start'
      } ${className}`}
      style={props.style}
    >
      {
        <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
          {buttonFilter && <div className="btn-filter-toolbar">{buttonFilter}</div>}
          <div className="group-btn-toolbar">
            {buttons.map((child, index) => (
              <Fragment key={index}>{child}</Fragment>
            ))}
          </div>
        </div>
      }
    </ButtonToolbar>
  );
};

export default Toolbar;
